import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle } from 'lucide-react';
import { usePASClientAuth } from '../../context/PASClientAuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { token } = usePASClientAuth();
  const [state, setState] = useState({ status: 'loading' });

  useEffect(() => {
    if (!token) return;
    axios.post(`${API}/pas-banking/subscription/confirm?session_id=${params.get('session_id')}`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setState({ status: 'ok', title: res.data.subscription.title }))
      .catch(err => setState({ status: 'error', message: err.response?.data?.detail || 'Could not confirm subscription' }));
  }, [token, params]);

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 max-w-md w-full text-center" data-testid="subscription-success-card">
        {state.status === 'loading' && <p className="text-slate-400">Confirming your subscription...</p>}
        {state.status === 'ok' && (<><CheckCircle className="w-14 h-14 text-emerald-400 mx-auto mb-3" /><p className="text-white text-xl font-bold">Welcome aboard</p><p className="text-amber-300 mt-2" data-testid="subscription-success-title">{state.title}</p></>)}
        {state.status === 'error' && (<><XCircle className="w-14 h-14 text-red-400 mx-auto mb-3" /><p className="text-red-400" data-testid="subscription-success-error">{state.message}</p></>)}
        <button onClick={() => navigate('/pas/banking')} className="mt-6 px-5 py-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg" data-testid="subscription-success-continue-btn">Go to Banking &amp; Credit</button>
      </div>
    </div>
  );
}
